import { Component, Input, OnInit, AfterViewInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import * as _ from "lodash";
@Component({
  selector: "kreform-field-ion-select",
  template: `
    <div class="multi">
      <div class="multi_head">
        <ng-container *ngIf="selectType == 'multiple'; else other">
          <ion-item>
            <ion-checkbox
              [(ngModel)]="isAllChecked"
              (ionChange)="checkAll($event)"
            ></ion-checkbox>
            <ion-label>
              全选
              <span>（{{ selectedNum }}/{{ options.length }}）</span></ion-label
            >
          </ion-item>
          <div>
            <ion-button size="small" fill="clear" (click)="dismissModel(false)"
              >取消</ion-button
            >
            <ion-button size="small" fill="clear" (click)="dismissModel(true)"
              >确定</ion-button
            >
          </div>
        </ng-container>
        <ng-template #other>
          <ion-button size="small" fill="clear" (click)="dismissModel(false)"
            >取消</ion-button
          >
          <ion-button size="small" fill="clear" (click)="dismissModel(true)"
            >确定</ion-button
          >
        </ng-template>
      </div>
      <div class="multi_scroll">
        <ion-item
          class="multi_scroll_item hairlines-bottom"
          *ngFor="let row of options"
          (click)="selectType == 'single' ? singleCheck(row.value) : ''"
        >
          <ion-checkbox
            [(ngModel)]="row.checked"
            (ionChange)="selectType == 'multiple' ? setSelectNum() : ''"
          ></ion-checkbox>
          <ion-label>{{ row.label }}</ion-label>
        </ion-item>
      </div>
    </div>
  `,
})
export class KreFormFieldIonSelectComponent implements OnInit, AfterViewInit {
  isAllChecked = false;
  // 缓存-当前选中
  selectedNum = 0;
  _options: any; // 可选项
  _options_old: any; // 可选项

  @Input() selectType = "multiple"; //single

  @Input()
  public get options(): any {
    return this._options;
  }
  public set options(value: any) {
    this._options = _.cloneDeep(value);
    this._options_old = value;
  }

  constructor(public modalController: ModalController) {}

  //全选
  checkAll(e: any) {
    if (this.isAllChecked == true) {
      this.options.forEach((e) => {
        e.checked = true;
      });
    } else {
      // 全选后取消某一项不清空选中效果判断
      if (this.selectedNum === this.options.length) {
        this.options.forEach((e) => {
          e.checked = false;
        });
      }
    }

    this.setSelectNum();
  }

  //筛选选中
  setSelectNum() {
    this.selectedNum = this.options.filter((item) => item.checked).length;
    this.isAllChecked =
      this.options.length > 0 && this.selectedNum === this.options.length;
  }

  singleCheck(value) {
    this.options.map((element) => {
      element.checked = element.value === value;
      return element;
    });
  }

  // 0 取消 / 1 确定
  dismissModel(type) {
    let selectOptions = [];
    if (type) {
      selectOptions = this.options
        .filter((item) => {
          return item.checked;
        })
        .map((item) => {
          return { label: item.label, value: item.value };
        });
      this.modalController.dismiss(selectOptions);
    } else {
      this.modalController.dismiss();
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {}
}
